import React, { useState, useEffect } from "react";
import "../locate/Locate.css";
import Loader from "../subComponents/Loader.jsx";
import { getFirestore, collection, getDocs,onSnapshot  } from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from '@mui/material/TextField';
import { GOOGLE_MAP_API_KEY } from "../../Constatns";
import MyMap from "../gMap/MyMap";
import { getSubOrdinates } from "../../actions/userActions/tasks/taskAction.js";
import MultiSelect from "../designSystem/MultiSelect.jsx";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate.js";

const Locate = () => {
  const db = getFirestore();
  const colRef = collection(db, "Location");
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const employeeId = user?.result[0]?.user?.id || false;

  const [locations, setLocations] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [availableEmployees, setAvailableEmployees] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 });
  const [mapZoom, setMapZoom] = useState(2);
  const [loadMap, setLoadMap] = useState(false);
  const employees = useSelector((state) => state.tasks_reducer.subOrdinates);

  const isLoading = useSelector((state) => state.tasks_reducer.isSubordinatesLoading);
  

  useEffect(() => {
    const unsubscribe = onSnapshot(colRef, (snapshot) => {
      const locs = snapshot.docs.map((doc) => ({ ...doc.data() }));
      setLocations([...locs]);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    dispatch(getSubOrdinates(employeeId, -1, 0, ""));
  }, [dispatch, employeeId]);

  useEffect(() => {
  if (Array.isArray(employees) && employees.length > 0) {
    setAvailableEmployees(employees);

    if (selectedEmployees.length === 0) {
      setSelectedEmployees(employees);
    }
  }
}, [employees]);


  useEffect(() => {
    if (Array.isArray(locations) && locations.length > 0) {
      const employeeMarkers = selectedEmployees
        .map((employee) => {
          const location = locations.find((loc) => loc.id === employee.id);
          return location
            ? {
                designation: location.designation,
                email: location.email,
                title: `${location.first_name} ${location.last_name}`,
                id: location.id,
                lat: parseFloat(location.latitude),
                lng: parseFloat(location.longitude),
                time_stamp: moment
                  .unix(location.time_stamp.seconds)
                  .format("MMMM Do YYYY, h:mm:ss a"),
                reportsTo: location.reports_to,
              }
            : null;
        })
        .filter(Boolean);

      setMarkers(employeeMarkers);
      if (employeeMarkers.length > 0) {
        const avgLat = employeeMarkers.reduce(
          (sum, marker) => sum + marker.lat,
          0
        ) / employeeMarkers.length;

        const avgLng = employeeMarkers.reduce(
          (sum, marker) => sum + marker.lng,
          0
        ) / employeeMarkers.length;

        setMapCenter({ lat: avgLat, lng: avgLng });
        setMapZoom(7);
      } else {
        setMapZoom(2);
      }
    }
  }, [locations, selectedEmployees]);
  const handleEmployeeChange = (selectedIds) => {
  const selected = employees.filter((emp) => selectedIds.includes(emp.id));
  setSelectedEmployees(selected);

  const updatedAvailable = employees.filter(
    (emp) => !selectedIds.includes(emp.id)
  );
  setAvailableEmployees(updatedAvailable);
};

  
  const employeeOptions = Array.isArray(employees)
  ? employees.map((emp) => ({
      value: emp.id,
      label: `${emp.firstName} ${emp.lastName}`,
      data: emp, // optionally keep full object if needed
    }))
  : [];

  const loadGoogleMapScript = (callback) => {
    if (
      typeof window.google === "object" &&
      typeof window.google.maps === "object"
    ) {
      callback();
    } else {
      const googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}`;
      window.document.body.appendChild(googleMapScript);
      googleMapScript.addEventListener("load", callback);
    }
  };

  useEffect(() => {
    loadGoogleMapScript(() => {
      setLoadMap(true);
    });
  }, []);

 
  

  return (
    <>
    <LoadingOverlay isVisible={isLoading} />
    <div className="outer-div">
    <div className="row">
        <div className="col-12">
        {employeeOptions.length > 0 && (
  <MultiSelect
    options={employeeOptions}
    value={selectedEmployees.map((emp) => emp.id)}
    onChange={handleEmployeeChange}
    placeholder={t("employee")}
    label={t("employee")}
    isSearchable={true}
  />
)}


          <br />
        </div>
      </div>
      <div className="locate-map-container" id="map">
        {!loadMap ? (
          <div className="mt-40">
            <Loader colored={true} />
          </div>
        ) : (
          <MyMap markerList={markers} mapCenter={mapCenter} mapZoom={mapZoom} />
        )}
      </div>
    </div>
      
    </>
  );
};

export default Locate;